const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirectPath'

const isBrowser =
  typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'

export const savePostLoginRedirectPath = (path: string) => {
  if (!isBrowser) {
    return
  }

  try {
    window.sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path)
  } catch {
    //
  }
}

export const consumePostLoginRedirectPath = () => {
  if (!isBrowser) {
    return null
  }

  try {
    const storedPath = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)

    if (storedPath) {
      window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
    }

    return storedPath
  } catch {
    return null
  }
}
